import React, { useEffect, useState } from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import MoreProducts from '../../Components/MoreProducts/MoreProducts'
import Flyer from '../../Components/Flyer/Flyer'
import './Demo.css'
import Footer from '../../Components/Footer/Footer'
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../Components/Cart/Cart'
import Developer from '../../Components/Developer/Developer'
import baseURL from '../../Components/url'
import { setSEO, addJSONLD } from '../../Components/seo'
export default function Demo() {
    const api = baseURL;
    const [subBg, setSubBg] = useState(null);
    const [correo, setCorreo] = useState('');
    const [subOk, setSubOk] = useState(false);
    useEffect(() => { fetch(`${api}/suscriptoresConfigGet.php`, { method:'GET' }).then(r=>r.json()).then(d=>{ setSubBg(d.fondo || null); }).catch(()=>{}); }, [api]);
    useEffect(()=>{
      setSEO({
        title: 'Kingtown Sport – Uniformes Deportivos Personalizados',
        description: 'Fabricamos uniformes deportivos personalizados en Colombia. Calidad, precios mayoristas y diseños exclusivos.',
        keywords: 'uniformes deportivos, uniformes personalizados, DTF, sublimación, confección deportiva',
        ogImage: `${api}/logo.png`,
        ogType: 'website'
      });
      addJSONLD({
        '@context': 'https://schema.org/',
        '@type': 'LocalBusiness',
        name: 'Kingtown Sport',
        image: `${api}/logo.png`,
        telephone: '3209430798',
        address: { '@type': 'PostalAddress', addressCountry: 'CO' }
      });
    }, [api]);
    const suscribir = async (e) => {
        e.preventDefault();
        if (!correo.trim()) return;
        try{ await fetch(`${api}/suscriptoresPost.php`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ correo }) }); setSubOk(true); localStorage.setItem('flyerSubscribed','1'); setCorreo(''); }catch(_){ }
    };
    return (
        <section className='demo'>
            <Flyer />
            <Banners />
            <MoreProducts />
            <Products />
            <div className='subscribe-card' style={{ backgroundImage: subBg ? `url(${/^https?:/i.test(String(subBg)) ? subBg : (api + '/' + String(subBg).replace(/^\//,''))})` : 'none' }}>
                <div className='subscribe-overlay'>
                    <h3>Suscríbete para recibir novedades</h3>
                    {!subOk ? (
                        <form className='subscribe-form' onSubmit={suscribir}>
                            <input type='email' placeholder='Email...' value={correo} onChange={e=>setCorreo(e.target.value)} />
                            <button type='submit'>Suscribirme</button>
                        </form>
                    ) : (
                        <div className='subscribe-ok'>¡Gracias por suscribirte!</div>
                    )}
                </div>
            </div>
            <Footer />
            <Developer />
            <BtnWhatsapp />
            <Cart />
        </section>
    )
}
